/* <kenra-education-hero> — Education page hero (WEB-6141).
 *
 * Click-to-play for the full-bleed hero film: the poster + custom triangle
 * play button show on load (no autoplay); clicking the button plays the video
 * inline with native controls and drops the overlay (via .is-playing). */
if (!customElements.get('kenra-education-hero')) {
  customElements.define(
    'kenra-education-hero',
    class KenraEducationHero extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('[data-hero-play]');
        const video = this.querySelector('[data-hero-video]');
        if (!btn || !video) return;

        btn.addEventListener('click', () => {
          // Only drop the overlay once playback actually starts — if play()
          // rejects (blocked/missing source) the poster + button stay so the
          // user can retry rather than being left with a dead hero.
          const reveal = () => {
            video.controls = true;
            this.classList.add('is-playing');
          };
          const played = video.play();
          if (played && typeof played.then === 'function') {
            played.then(reveal).catch(() => {});
          } else {
            reveal();
          }
        });
      }
    }
  );
}
